import { isDefinedString } from "et3-type-guards";
import getCorePopUpStore from "../../../../stores/core/core-popup-store";
import getUserEditProfileStore from "../../../../stores/user-store/edit-profile-store";
import Et3Button from "../../../et3-button";
import ET3Div from "../../../et3-div";
import { withLiteObserverAndTheme } from "../../../et3-enhanced-render";

const EditPopUpOKButton = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const { key } = getCorePopUpStore().getEditPopUpData();
  const isEnabled = isDefinedString(
    getCorePopUpStore().editPopUpValue.get().label
  );

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="center"
      alignItems="flex-start"
      withShadow={false}
      width={350}
      height={105}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Button
        isEnabled={isEnabled}
        onClick={() => {
          getUserEditProfileStore().editUserData({
            key: key,
            value: `${getCorePopUpStore().editPopUpValue.get().value}`
          });
          getCorePopUpStore().editPopUpVisibleType.set("");
        }}
        type="GET"
        size="LARGE"
        text="OK"
      />
    </ET3Div>
  );
});

export default EditPopUpOKButton;
